import { render, staticRenderFns } from "./PublicShareSidebar.vue?vue&type=template&id=1742b97d&scoped=true"
import script from "./PublicShareSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareSidebar.vue?vue&type=script&lang=js"
import style0 from "./PublicShareSidebar.vue?vue&type=style&index=0&id=1742b97d&prod&lang=css"
import style1 from "./PublicShareSidebar.vue?vue&type=style&index=1&id=1742b97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742b97d",
  null
  
)

export default component.exports